import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const SITE = "https://roygym.hu";
const DEFAULT_OG_IMAGE = `${SITE}/og/og-default.jpg`;
const DEFAULT_OG_IMAGE_WIDTH = 1200;
const DEFAULT_OG_IMAGE_HEIGHT = 630;

function getOgImageMimeType(imageUrl) {
  const normalizedImageUrl = String(imageUrl ?? "")
    .split("?")[0]
    .trim()
    .toLowerCase();

  if (normalizedImageUrl.endsWith(".jpg") || normalizedImageUrl.endsWith(".jpeg")) {
    return "image/jpeg";
  }

  if (normalizedImageUrl.endsWith(".webp")) {
    return "image/webp";
  }

  if (normalizedImageUrl.endsWith(".gif")) {
    return "image/gif";
  }

  if (normalizedImageUrl.endsWith(".svg")) {
    return "image/svg+xml";
  }

  return "image/png";
}

export default function Seo({
  title,
  description,
  noindex = false,
  image,
  imageWidth = DEFAULT_OG_IMAGE_WIDTH,
  imageHeight = DEFAULT_OG_IMAGE_HEIGHT,
}) {
  const { pathname } = useLocation();
  const cleanPath = pathname === "/" ? "/" : pathname.replace(/\/+$/, "");
  const canonical = `${SITE}${cleanPath}`;
  const ogImage = image || DEFAULT_OG_IMAGE;
  const ogImageType = getOgImageMimeType(ogImage);

  return (
    <Helmet>
      {/* Primary */}
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={canonical} />

      {/* Robots */}
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonical} />
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:type" content={ogImageType} />
      <meta property="og:image:width" content={String(imageWidth)} />
      <meta property="og:image:height" content={String(imageHeight)} />
      <meta property="og:image:alt" content={title || "ROY GYM"} />
      <meta property="og:image:secure_url" content={ogImage} />
      <meta name="twitter:card" content="summary_large_image" />
      {title && <meta name="twitter:title" content={title} />}
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={ogImage} />
      <meta name="twitter:image:alt" content={title || "ROY GYM"} />
    </Helmet>
  );
}
